import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = ["menu", "selectedText", "hiddenInput", "otherInput", "button"];

    connect() {
        document.addEventListener("click", this.closeDropdown.bind(this));
    }

    toggle(event) {
        event.stopPropagation();
        
        if (this.menuTarget.classList.contains("hidden")) {
            this.closeAllDropdowns();
            this.menuTarget.classList.remove("hidden");
        } else {
            this.menuTarget.classList.add("hidden");
        }
    }

    select(event) {
        const value = event.target.dataset.value;

        if (value === "Other") {
            this.selectedTextTarget.classList.add("hidden");
            this.otherInputTarget.classList.remove("hidden"); 
            this.otherInputTarget.focus();
            this.hiddenInputTarget.value = "";
        } else {
            this.selectedTextTarget.classList.remove("hidden");
            this.selectedTextTarget.textContent = event.target.textContent;
            this.hiddenInputTarget.value = value;
            this.otherInputTarget.classList.add("hidden");
            this.menuTarget.classList.add("hidden");
        }
    }

    handleOtherInput(event) {
        if (event.key === "Enter") {
            event.preventDefault(); 
            this.saveOtherValue();
        }
    }

    saveOtherValue() {
        const inputValue = this.otherInputTarget.value.trim();
        if (inputValue !== "") {
            this.selectedTextTarget.textContent = inputValue;
            this.hiddenInputTarget.value = inputValue;
        }
        this.menuTarget.classList.add("hidden"); 
    }

    confirmOther() {
        const otherValue = this.otherInputTarget.value.trim();
        if (otherValue) {
            this.selectedTextTarget.classList.remove("hidden");
            this.selectedTextTarget.textContent = otherValue;
            this.hiddenInputTarget.value = otherValue;
            this.otherInputTarget.classList.add("hidden");
            this.menuTarget.classList.add("hidden");
        }
    }

    closeDropdown(event) {
        if (!this.element.contains(event.target)) {
            this.saveOtherValue(); 
            this.menuTarget.classList.add("hidden");
        }
    }

    closeAllDropdowns() {
        document.querySelectorAll("[data-dropdown-pm-target='menu']").forEach(menu => {
            menu.classList.add("hidden");
        });
    }
}
